module.exports = __webpack_public_path__ + "img/io.eddc8a4a.svg";